import { combineReducers } from '@reduxjs/toolkit';
import { searchSlice } from './model/search';

const searchReducer = combineReducers({
  search: searchSlice.reducer,
});

export default searchReducer;
